import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from 'common/Container';
import NotFoundIllustration from 'svg/illustrations/NotFound';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation } from 'react-router-dom';

const CONTACT_PHONE_DISPLAY = '+1 (614) 579-0661';
const CONTACT_PHONE_LINK = 'tel:+16145790661';
const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

const primaryActionSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 48,
  paddingX: 3,
  paddingY: 1.5,
  borderRadius: 1,
  backgroundColor: 'primary.main',
  color: 'primary.contrastText',
  fontWeight: 700,
  textDecoration: 'none',
  '&:hover': {
    backgroundColor: 'primary.dark',
    textDecoration: 'none',
  },
};

const secondaryActionSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 48,
  paddingX: 3,
  paddingY: 1.5,
  borderRadius: 1,
  border: 1,
  borderColor: 'primary.main',
  color: 'primary.main',
  fontWeight: 700,
  textDecoration: 'none',
  '&:hover': {
    backgroundColor: 'action.hover',
    textDecoration: 'none',
  },
};

const FormFailed = () => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY, {
    defaultMatches: false,
  });
  const location = useLocation();
  const errorMessage = location.state?.errorMessage;

  return (
    <Box
      minHeight={'calc(100vh - 64px - 183px)'}
      height={'100%'}
      display={'flex'}
      alignItems={'center'}
    >
      <Container>
        <Grid container spacing={4}>
          <Grid item container justifyContent={'center'} xs={12}>
            <Box height={'100%'} width={'100%'} maxWidth={460}>
              <NotFoundIllustration width={'100%'} height={'100%'} />
            </Box>
          </Grid>
          <Grid
            item
            container
            alignItems={'center'}
            justifyContent={'center'}
            xs={12}
          >
            <Box maxWidth={720}>
              <Typography
                variant="h4"
                component={'h1'}
                align={'center'}
                gutterBottom
                sx={{ fontWeight: 700 }}
              >
                We couldn&apos;t send your request
              </Typography>
              <Typography component="p" color="textSecondary" align={'center'}>
                Please go back and resubmit the form. If your project is urgent,
                call us at{' '}
                <Link href={CONTACT_PHONE_LINK} underline="hover">
                  {CONTACT_PHONE_DISPLAY}
                </Link>
                .
              </Typography>
              {errorMessage ? (
                <Typography
                  component="p"
                  color="textSecondary"
                  align={'center'}
                  sx={{ marginTop: 2 }}
                >
                  Details: {errorMessage}
                </Typography>
              ) : null}
              <Box display={'flex'} justifyContent={'center'} flexWrap={'wrap'} gap={2} marginTop={3}>
                <Link
                  underline={'none'}
                  component={'a'}
                  href={'/contact'}
                  sx={primaryActionSx}
                >
                  Resubmit form
                </Link>
                {isMobile ? (
                  <Link
                    underline={'none'}
                    component={'a'}
                    href={CONTACT_PHONE_LINK}
                    sx={secondaryActionSx}
                  >
                    Call us now
                  </Link>
                ) : null}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FormFailed;